import { Outlet } from "react-router"

export function GuestLayout() {
  return (
    <main className="mx:p-0 mx-auto flex min-h-[80vh] px-4 md:max-w-screen-md md:px-6 lg:max-w-screen-lg lg:px-8 xl:max-w-screen-xl">
      <Outlet />
    </main>
  )
}
